import commonStyles from "../../../common.module.css"
import { useEffect, useMemo, useRef, useState } from "react"
import { MultiSelect } from "primereact/multiselect"
import { useUsers } from "../../../../api/queries/useUsers"
import { Button } from "primereact/button"
import { useHistory } from "react-router-dom"
import api from "../../../../api"
import { Toast } from "primereact/toast"
import MachineMultiFilter from "../../../../filter/MachineMultiFilter"
import TaskStateMultiFilter from "../../../../filter/TaskStateMultiFilter"
import UserMultiFilter from "../../../../filter/UserMultiFilter"
import MachineTypeMultiFilter from "../../../../filter/MachineTypeMultiFilter"
import TaskTagMultiFilter from "../../../../filter/TaskTagMultiFilter"
import TeamMultiFilter from "../../../../filter/TeamMultiFilter"
import OperationMultiFilter from "../../../../filter/OperationMultiFilter"
import { InputText } from "primereact/inputtext"
import { useDebounce } from "../../../../hook/useDebounce"
import query from "../../../../function/query"
import { Fieldset } from "primereact/fieldset"

export default function TaskReportRemindForm() {
  const history = useHistory()
  const toastRef = useRef()

  const [machine, setMachine] = useState([])
  const handleMachineChange = (e) => setMachine(e.target.value || [])

  const [taskState, setTaskState] = useState([])
  const handleTaskStateChange = (e) => setTaskState(e.target.value || [])

  const [createdBy, setCreatedBy] = useState([])
  const handleCreatedByChange = (e) => setCreatedBy(e.target.value || [])

  const [machineType, setMachineType] = useState([])
  const handleMachineTypeChange = (e) => setMachineType(e.target.value || [])

  const [taskTag, setTaskTag] = useState([])
  const handleTaskTagChange = (e) => setTaskTag(e.target.value || [])

  const [team, setTeam] = useState([])
  const handleTeamChange = (e) => setTeam(e.target.value || [])

  const [userOption, setUserOption] = useState([])
  const handleUserOptionChange = (e) => setUserOption(e.target.value || [])

  const [operation, setOperation] = useState([])
  const handleOperationChange = (e) => setOperation(e.target.value || [])

  const [taskOrder, setTaskOrder] = useState("")
  const taskOrderDebounced = useDebounce(taskOrder, 500)
  const handleTaskOrderChange = (e) => setTaskOrder(e.target.value)

  const [reports, setReports] = useState([])
  const [selectedReports, setSelectedReports] = useState([])
  const onSelectedReportsChange = (e) => setSelectedReports(e.value)

  const [selectedUsers, setSelectedUsers] = useState([])
  const onSelectedUsersChange = (e) => setSelectedUsers(e.value)

  const [isLoading, setIsLoading] = useState(false)

  const { data: users = [] } = useUsers()
  const usersWithEmail = useMemo(() => users.filter((user) => !!user.email), [users])

  const onBack = () => history.push("/tasks/reports")

  useEffect(() => {
    const getData = () => {
      setIsLoading(true)

      let prms = {
        task_order: taskOrderDebounced,
        view: "actove",
        type: "REPORT",
        limit: 25,
        offset: 0,
        order: "created_desc",
      }

      if (machine.length > 0) prms.machine = machine
      if (taskState.length > 0) prms.state = taskState
      if (createdBy.length > 0) prms.created_by = createdBy
      if (machineType.length > 0) prms.machine_type = machineType
      if (taskTag.length > 0) prms.tag = taskTag
      if (team.length > 0) prms.team = team
      if (userOption.length > 0) prms.user = userOption
      if (operation.length > 0) prms.operation = operation

      const queryParamsStr = query.toString(prms)

      api.get(`/tasks${queryParamsStr}`)
        .then(({ data }) => {
          setReports(data.data)
        })
        .finally(() => setIsLoading(false))
        .catch(() => { })
    }

    getData()
  }, [taskState, machine, taskTag, team, history, userOption, operation, machineType, createdBy, taskOrderDebounced])

  const onSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    const payload = selectedReports.map((report) => ({
      task_uuid: report,
      users: selectedUsers
    }))

    try {
      await api.post("/task-notification", payload)
      toastRef.current.show({ severity: 'success', summary: 'Připomenutí vytvořeno.' });
      reset()
    } catch {
      reset()
    }
  }

  const reset = () => {
    setIsLoading(false)
    setMachine([])
    setTaskState([])
    setCreatedBy([])
    setMachineType([])
    setTaskTag([])
    setTeam([])
    setUserOption([])
    setOperation([])
    setTaskOrder("")
    setSelectedReports([])
    setSelectedUsers([])
  }

  return (
    <div className="col-12 md:col-6">
      <Toast ref={toastRef} />

      <form onSubmit={onSubmit}>
        <div className="p-fluid">
          <Fieldset className={"p-0 mb-3"}>
            <div className="grid">
              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Stroj:</label>
                  <MachineMultiFilter value={machine} onChange={handleMachineChange} />
                </div>
              </div>
              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Stav:</label>
                  <TaskStateMultiFilter value={taskState} onChange={handleTaskStateChange} />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Založil:</label>
                  <UserMultiFilter value={createdBy} onChange={handleCreatedByChange} placeholder={"Založil"} />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Typ stroje:</label>
                  <MachineTypeMultiFilter value={machineType} onChange={handleMachineTypeChange} />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Typ:</label>
                  <TaskTagMultiFilter value={taskTag} onChange={handleTaskTagChange} />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Tým:</label>
                  <TeamMultiFilter value={team} onChange={handleTeamChange} />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Odpovědná osoba:</label>
                  <UserMultiFilter value={userOption} onChange={handleUserOptionChange} placeholder={"Odpovědná osoba"} />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Řeší provoz:</label>
                  <OperationMultiFilter value={operation} onChange={handleOperationChange} />
                </div>
              </div>

              <div className="col-12 md:col-6">
                <div className={"field mb-0"}>
                  <label>Zakázka nebo tavba:</label>
                  <InputText value={taskOrder} onChange={handleTaskOrderChange} placeholder="Zakázka nebo tavba"
                    style={{ fontSize: "1rem", borderColor: "#ced4da" }}
                  />
                </div>
              </div>
            </div>
          </Fieldset>

          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Hlášení:</label>
            <MultiSelect value={selectedReports} options={reports} optionValue={"task_uuid"}
              optionLabel={"name"} emptyMessage={"Žádné záznamy"}
              onChange={onSelectedReportsChange}
              filter={true} filterBy="name" />
          </div>

          <div className={"field"}>
            <label className={commonStyles.labelRequired}>Uživatelé:</label>
            <MultiSelect value={selectedUsers} options={usersWithEmail} optionValue={"uuid"}
              optionLabel={"name"} emptyMessage={"Žádné záznamy"}
              onChange={onSelectedUsersChange} disabled={selectedReports.length === 0}
              filter={true} filterBy="name" />
          </div>
        </div>

        <div className={"flex"}>
          <Button type={"button"} label={"Zpět"} className={"p-button-warning m-1"}
            onClick={onBack} />

          <div className={"ml-auto"}>
            <Button type={"submit"} label={"Uložit"} className={"m-1"}
              disabled={isLoading || selectedReports.length === 0 || selectedUsers.length === 0} />
          </div>
        </div>
      </form>
    </div>
  )
}
